// extracted by mini-css-extract-plugin
export default {"container":"select-tags_container__xdA6r","tags-count":"select-tags_tags-count__bj8G8"};